var map = {
	"./address.svg": "qREA",
	"./alley.svg": "oS1A",
	"./assets.svg": "7tfs",
	"./cms-subject.svg": "zjZS",
	"./cms-topic.svg": "2SiQ",
	"./cms.svg": "fHET",
	"./dashboard-city.svg": "X3ij",
	"./dashboard-data.svg": "WeQ4",
	"./dashboard-function.svg": "zSb/",
	"./dashboard-icon-date.svg": "GxPu",
	"./dashboard-icon-deal.svg": "op5O",
	"./dashboard-icon-pay.svg": "xJeH",
	"./dashboard-icon-publish.svg": "LGww",
	"./dashboard-icon-report.svg": "2joQ",
	"./dashboard-icon-reposit.svg": "9Vmx",
	"./dashboard-user.svg": "EoZ1",
	"./dashboard.svg": "BCGP",
	"./dep-anjian.svg": "v/vk",
	"./dep-chengjian.svg": "xQY8",
	"./dep-fenguan.svg": "px+o",
	"./dep-health.svg": "/fLr",
	"./dep-huguan.svg": "SSR3",
	"./dep-jingjishe.svg": "gdUN",
	"./department.svg": "zLNx",
	"./detail.svg": "rSG0",
	"./document-1.svg": "qFUe",
	"./document.svg": "mDNq",
	"./domicile-birth.svg": "AtEG",
	"./domicile-death.svg": "VxM6",
	"./domicile-division.svg": "FhLb",
	"./domicile-movein.svg": "ylyj",
	"./domicile-moveout.svg": "4YTj",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fund.svg": "l9+r",
	"./home.svg": "U9Ws",
	"./house.svg": "DUyu",
	"./login-mall.svg": "xzZT",
	"./login-platform.svg": "r//b",
	"./login-zhaoyang.svg": "Pisw",
	"./map.svg": "maBF",
	"./marker.svg": "0+/s",
	"./meeting.svg": "kmvE",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./party-member.svg": "K2Ec",
	"./party.svg": "iFQs",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./reservation.svg": "AWon",
	"./shop.svg": "hert",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./statistic-chartable.svg": "XyuE",
	"./statistic.svg": "afyG",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user-group.svg": "AWJP",
	"./user.svg": "VdD3",
	"./video.svg": "3JNx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 87